import { RootState } from "../store";

export const userSelect = (state: RootState) => state.userReducer;
